module.exports = __webpack_public_path__ + "static/media/spectrum.c25dee62.png";